import SuccessAccountCreationModal from './SuccessAccountCreationModal';
export default SuccessAccountCreationModal;
